
import {disableScroll,enableScroll} from '@/js/global.js'
export const openVideo = function(url) {
    return function(){
        disableScroll();
    document.querySelector(".video").src = url;
    document.querySelector(".clip").classList.add("active");
    document.querySelector(".video").currentTime = 0;
    document.querySelector(".video").play();
    }
};
export const closeVideo = function() {
    enableScroll();
    document.querySelector(".clip").classList.remove("active");
    document.querySelector(".video").pause();
};
